import {ChangeDetectionStrategy, Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {ItemPopup} from '../item/item.popup';

@Component({
  selector: 'p-new-item',
  templateUrl: './new-item.popup.html',
  styleUrls: ['./new-item.popup.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class NewItemPopup {
  selectedIndex = -1;
  search = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
                section_id: number,
                section_name: string,
                description: string,
                items: { img: string, name: string }[]
              },
              public dialog: MatDialog,
              public itemRef: MatDialogRef<ItemPopup>) {
  }

  newItem() {
    const dialogRef = this.dialog.open(ItemPopup, {width: '1400px'});
    dialogRef.afterClosed().subscribe(result => {
      if (!(result == false || result == undefined)) {
        this.itemRef.close(result);
      }
    });
  }
}
